import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/contractOutOfScope/initialState.contractOutOfScope.data';
import {
    fetchOOSCountries as fetchOOSCountriesAPI,
    fetchLaborFees as fetchLaborFeesAPI,
    fetchHardwareFees as fetchHardwareFeesAPI,
    fetchHardwareLogistics as fetchHardwareLogisticsAPI,
    updateHwFeesNonStandard as updateHwFeesNonStandardAPI,
    updateHwLogisticsNonStandard as updateHwLogisticsNonStandardAPI,
    updateHwLogisticsNonStandardConsumableFee as updateHwLogisticsNonStandardConsumableFeeAPI,
} from '../../../../apis/contractsAPI';
import { CONTRACTS_DATA, handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_CONTRACTS_OUTOFSCOPE } from '../../../../constants/actionCreator';

//API to get COuntries Data
export const fetchOOSCountries = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.FETCH_OOS_COUNTRIES,
  fetchOOSCountriesAPI
);

//API to get Labor Fees Data
export const fetchLaborFeesData = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.FETCH_LABOR_FEES_DATA,
  fetchLaborFeesAPI
);

//API to get Hardware Fees Data
export const fetchHardwareFeesData = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.FETCH_HARDWARE_FEES_DATA,
  fetchHardwareFeesAPI
);

//API to get Hardware Logistics Data
export const fetchHardwareLogisticsData = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.FETCH_HARDWARE_LOGISTICS_DATA,
  fetchHardwareLogisticsAPI
);

//API to Update Hardware Fees and Hardware Logistics Non Standard Fees
export const updateHwFeesNonStandard = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.UPDATE_HARDWARE_FEES_NON_STANDARD_FEES,
  updateHwFeesNonStandardAPI
);

//API to Update Hardware Fees and Hardware Logistics Non Standard Fees
export const updateHwLogisticsNonStandard = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.UPDATE_HARDWARE_LOGISTICS_NON_STANDARD_FEES,
  updateHwLogisticsNonStandardAPI
);

//API to Update Hardware Logistics Non Standard Consumable Fees
export const updateHardwareLogisticsNonStandardConsumableFees = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS_OUTOFSCOPE.UPDATE_HARDWARE_LOGISTICS_NON_STANDARD_CONSUMABLE_FEES,
  updateHwLogisticsNonStandardConsumableFeeAPI
);

const contractOutOfScopeSlice = createSlice({
  name: 'contractOutOfScopeSlice',
  initialState,
  reducers: {
    handleReset: () => initialState,
    handleAPIResponseOutOfScope: (state, action) => {
      state.apiSuccessResponseOutOfScope = action?.payload || false;
    },
    setOpenAlertBoxFees: (state) => {
      state.alertDialogFees = true;
    },
    setCloseAlertBoxFees: (state) => {
      state.alertDialogFees = false;
    },
    setOpenAlertBoxLogistics: (state) => {
      state.alertDialogLogistics = true;
    },
    setCloseAlertBoxLogistics: (state) => {
      state.alertDialogLogistics = false;
    },
    setAlertMessage: (state, action) => {
      state.alertText = action.payload;
    },
    handleOOSCountry: (state, action) => {
      state.oosCountryId = action?.payload?.value || CONTRACTS_DATA.outOfScopeTab.defaultCountryId;
    },
    handleHardwareFeesSelectedData: (state, action) => {
      state.hardwareFeesSelectedData = action?.payload || [];
    },
    handleHardwareLogisticsSelectedData: (state, action) => {
      state.hardwareLogisticsSelectedData = action?.payload || [];
    },
    //Non Archived Events - BEGIN
    handleOOSCountryNA: (state, action) => {
      state.oosCountryIdNA = action?.payload?.value || CONTRACTS_DATA.outOfScopeTab.defaultCountryId;
    },
    handleHwFeesData: (state, action) => {
      state.hwFeesData = action?.payload || [];
    },
    handleHwLogisticsData: (state, action) => {
      state.hwLogisticsData = action?.payload || [];
    },
    handleEditableConsumableFee: (state, action) => {
      state.isEditedNSConsumableFee = action?.payload || false;
    },
    handleHwLogisticsNSConsumableFees: (state, action) => {
      state.hwLogisticsNSConsumableFees = action?.payload || '';
    },
    handleUpdatedFeesRecords: (state, action) => {
      state.updatedFeesRecords = action?.payload || [];
    },
    handleUpdatedLogisticsRecords: (state, action) => {
      state.updatedLogisticsRecords = action?.payload || [];
    },
    handleUpdatedIndexRecords: (state, action) => {
      if(action?.payload?.grid === CONTRACTS_DATA.outOfScopeTab.hardwareFeesGrid) {
        state.updatedFeesRecords[action?.payload?.modifiedIndex] = action?.payload?.data || [];
        state.updatedFeesRecordsCount = state.updatedFeesRecords.length || 0;
      }

      if(action?.payload?.grid === CONTRACTS_DATA.outOfScopeTab.hardwareLogisticsGrid) {
        state.updatedLogisticsRecords[action?.payload?.modifiedIndex] = action?.payload?.data || [];
        state.updatedLogisticsRecordsCount = state.updatedLogisticsRecords.length || 0;
      }
    },
    handleResetLogisticsGridData: (state) => {
      state.hardwareLogisticsData = initialState.hardwareLogisticsData;
      state.hwLogisticsData = initialState.hwLogisticsData;
      state.updatedLogisticsRecords = initialState.updatedLogisticsRecords;
      state.updatedLogisticsRecordsCount = initialState.updatedLogisticsRecordsCount;
      state.isEditedNSConsumableFee = false;
    },
    handleResetFeesGridData: (state) => {
      state.hardwareFeesData = initialState.hardwareFeesData;
      state.hwFeesData = initialState.hwFeesData;
      state.updatedFeesRecords = initialState.updatedFeesRecords;
      state.updatedFeesRecordsCount = initialState.updatedFeesRecordsCount;
      state.isEditedNSConsumableFee = false;
    },
    handleRestoreLogisticsNonConsumableFees: (state) => {
      state.hwLogisticsNSConsumableFees = state.hardwareLogisticsSelectedData?.nonStandardConsumableFees;
    },
    handleIsSavedFlag: (state, action) => {
      if (action.payload === CONTRACTS_DATA.outOfScopeTab.isSaveHwFees) {
        state.isSavedFeesFlag = true;
      }
      if (
        action.payload === CONTRACTS_DATA.outOfScopeTab.isSaveHwLogisticsFees
      ) {
        state.isSavedLogisticsFlag = true;
      }
      if (
        action.payload ===
        CONTRACTS_DATA.outOfScopeTab.isSaveHwLogisticsConumableFees
      ) {
        state.isSavedConsumableFeesFlag = true;
      }
    },
    handleResetFlags: (state) => {
      state.isSavedFeesFlag = initialState.isSavedFeesFlag;
      state.isSavedLogisticsFlag = initialState.isSavedLogisticsFlag;
      state.isSavedConsumableFeesFlag = initialState.isSavedConsumableFeesFlag;
      state.isEditedNSConsumableFee = false;
    },
    handleResetAPICall: (state, action) => {
      state.apiSuccessResponseOOS[action?.payload] = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOOSCountries.pending, handlePending)
      .addCase(fetchOOSCountries.fulfilled, (state, action) => {
        state.oosCountriesData = action?.payload || [];
      })
      .addCase(fetchOOSCountries.rejected, handleRejection)
      
      .addCase(fetchLaborFeesData.pending, (state, action) => {
        handlePending(state, action);
        state.laborFeesData = [];
        state.isLaborFeesDataFound = null;
      })
      .addCase(fetchLaborFeesData.fulfilled, (state, action) => {
        state.laborFeesData = action?.payload?.laborFees || [];
        state.laborFeesDataCount = action?.payload?.totalRecords || 0;
        state.isLaborFeesDataFound = action?.payload?.laborFees?.length > 0;
      })
      .addCase(fetchLaborFeesData.rejected, (state, action) => {
        handleRejection(state, action);
        state.laborFeesData = [];
        state.laborFeesDataCount = 0;
        state.isLaborFeesDataFound = true;
      })
      
      .addCase(fetchHardwareFeesData.pending, (state, action) => {
        handlePending(state, action);
        state.hardwareFeesData = [];
        state.hwFeesData = [];
        state.isHardwareFeesDataFound = null;
      })
      .addCase(fetchHardwareFeesData.fulfilled, (state, action) => {
        state.hardwareFeesData = action?.payload?.hardwareFees || [];
        state.hwFeesData = action?.payload?.hardwareFees || [];
        if (action?.payload?.hardwareFees?.length > 0) {
          state.hardwareFeesData.forEach((data) => {
            data['nonStandardFees'] = Number(data['nonStandardFees'])
              ? parseFloat(data['nonStandardFees']).toFixed(2)
              : '';
            data['standardFees'] = Number(data['standardFees'])
              ? parseFloat(data['standardFees']).toFixed(2)
              : '';
          });

          state.hwFeesData.forEach((data) => {
            data['nonStandardFees'] = Number(data['nonStandardFees'])
              ? parseFloat(data['nonStandardFees']).toFixed(2)
              : '';
            data['standardFees'] = Number(data['standardFees'])
              ? parseFloat(data['standardFees']).toFixed(2)
              : '';
          });
        }
        state.hardwareFeesDataCount = action?.payload?.totalRecords || 0;
        state.isHardwareFeesDataFound = action?.payload?.hardwareFees?.length > 0;
      })
      .addCase(fetchHardwareFeesData.rejected, (state, action) => {
        handleRejection(state, action);
        state.hardwareFeesData = [];
        state.hardwareFeesDataCount = 0;
        state.isHardwareFeesDataFound = true;
      })
      
      .addCase(fetchHardwareLogisticsData.pending, (state, action) => {
        handlePending(state, action);
        state.hardwareLogisticsData = [];
        state.hwLogisticsData = [];
        state.isHardwareLogisticsDataFound = null;
        state.hardwareLogisticsSelectedData = initialState.hardwareLogisticsSelectedData;
      })
      .addCase(fetchHardwareLogisticsData.fulfilled, (state, action) => {
        state.hardwareLogisticsData = action?.payload?.hardwareLogistic || [];
        state.hwLogisticsData = action?.payload?.hardwareLogistic || [];
        if (action?.payload?.hardwareLogistic?.length > 0) {
          state.hardwareLogisticsData.forEach((data) => {
            data['nonStandardFees'] = Number(data['nonStandardFees'])
              ? parseFloat(data['nonStandardFees']).toFixed(2)
              : '';
            data['standardFees'] = Number(data['standardFees'])
              ? parseFloat(data['standardFees']).toFixed(2)
              : '';
            data['standardConsumableFees'] = Number(
              data['standardConsumableFees']
            )
              ? parseFloat(data['standardConsumableFees']).toFixed(2)
              : '';
            data['nonStandardConsumableFees'] = Number(
              data['nonStandardConsumableFees']
            )
              ? parseFloat(data['nonStandardConsumableFees']).toFixed(2)
              : '';
          });

          state.hwLogisticsData.forEach((data) => {
            data['nonStandardFees'] = Number(data['nonStandardFees'])
              ? parseFloat(data['nonStandardFees']).toFixed(2)
              : '';
            data['standardFees'] = Number(data['standardFees'])
              ? parseFloat(data['standardFees']).toFixed(2)
              : '';
            data['standardConsumableFees'] = Number(
              data['standardConsumableFees']
            )
              ? parseFloat(data['standardConsumableFees']).toFixed(2)
              : '';
            data['nonStandardConsumableFees'] = Number(
              data['nonStandardConsumableFees']
            )
              ? parseFloat(data['nonStandardConsumableFees']).toFixed(2)
              : '';
          });
        }
        state.hardwareLogisticsDataCount = action?.payload?.totalRecords || 0;
        state.isHardwareLogisticsDataFound = action?.payload?.hardwareLogistic?.length > 0;        
      })
      .addCase(fetchHardwareLogisticsData.rejected, (state, action) => {
        handleRejection(state, action);
        state.hardwareLogisticsData = [];
        state.hardwareLogisticsDataCount = 0;
        state.isHardwareLogisticsDataFound = true;
      })

      //Updating Hardware Fees - Non Standard Fees
      .addCase(updateHwFeesNonStandard.pending, (state, action) => {
        handlePending(state, action);
        state.hardwareFeesData = [];
        state.hwFeesData = [];
        state.isHardwareFeesDataFound = null;
        state.reloadHWFee = null;
        state.HWFeeLoader = true;
      })
      .addCase(updateHwFeesNonStandard.fulfilled, (state, action) => {
        state.updateHwFeesNonStFeesMsg = action?.payload || [];
        state.isHardwareFeesDataFound = true;
        state.apiSuccessResponseOOS.hardwareFeeUpdate = true;
        state.reloadHWFee = true;
        state.HWFeeLoader = false;
      })
      .addCase(updateHwFeesNonStandard.rejected, (state, action) => {
        handleRejection(state, action);
        state.hardwareFeesData = [];
        state.hardwareFeesDataCount = 0;
        state.isHardwareFeesDataFound = true;
        state.reloadHWFee = true;
        state.HWFeeLoader = false;
        state.apiSuccessResponseOOS.hardwareFeeUpdate = false;
      })

      //Updating Hardware Logistics Fees - Non Standard Fees
      .addCase(updateHwLogisticsNonStandard.pending, (state, action) => {
        handlePending(state, action);
        state.hardwareLogisticsData = [];
        state.hwLogisticsData = [];
        state.isHardwareLogisticsDataFound = null;
        state.hardwareLogisticsSelectedData = initialState.hardwareLogisticsSelectedData;
        state.reloadHwLogistics = null;
        state.HwLogisticsSLoader = true;
      })
      .addCase(updateHwLogisticsNonStandard.fulfilled, (state, action) => {
        state.updateHwLgNonStFeesMsg = action?.payload || [];
        state.apiSuccessResponseOOS.hardwareLogisticsUpdate = true;
        state.isHardwareLogisticsDataFound = true;
        state.reloadHwLogistics = true;
        state.HwLogisticsSLoader = false;
      })
      .addCase(updateHwLogisticsNonStandard.rejected, (state, action) => {
        handleRejection(state, action);
        state.hardwareLogisticsData = [];
        state.hardwareLogisticsDataCount = 0;
        state.isHardwareLogisticsDataFound = true;
        state.reloadHwLogistics = true;
        state.HwLogisticsSLoader = false;
        state.apiSuccessResponseOOS.hardwareLogisticsUpdate = false;
      })

      .addCase(updateHardwareLogisticsNonStandardConsumableFees.pending, handlePending)
      .addCase(updateHardwareLogisticsNonStandardConsumableFees.fulfilled, (state, action) => {
        state.updateHwLgNonStComableFeesMsg = action?.payload || [];
        state.apiSuccessResponseOOS.consumableFees = true;         
      })
      .addCase(updateHardwareLogisticsNonStandardConsumableFees.rejected, (state, action) => {
        handleRejection(state, action);
        state.apiSuccessResponseOOS.consumableFees = false;
      });
  },
});

export const {
  setOpenAlertBoxFees,
  setCloseAlertBoxFees,
  setOpenAlertBoxLogistics,
  setCloseAlertBoxLogistics,
  setAlertMessage,
  handleResetFeesGridData,
  handleRestoreLogisticsNonConsumableFees,
  handleResetLogisticsGridData,
  handleOOSCountry,
  handleOOSCountryNA,
  handleHardwareFeesSelectedData,
  handleHardwareLogisticsSelectedData,
  handleHwFeesData,
  handleHwLogisticsData,
  handleHwLogisticsNSConsumableFees,
  handleUpdatedFeesRecords,
  handleUpdatedLogisticsRecords,
  handleUpdatedIndexRecords,
  handleIsSavedFlag,
  handleReset,
  handleResetFlags,
  handleEditableConsumableFee,
  handleAPIResponseOutOfScope,
  handleResetAPICall
} = contractOutOfScopeSlice.actions;

export default contractOutOfScopeSlice.reducer;
